import { useState, useEffect, useRef, useCallback } from "react";
import { toast } from "react-toastify";

import user from "../assets/user.png";

const Newsletter = () => {
  const initialFormState = {
    email: "",
    captcha: "",
  };
  const [inputs, setInputs] = useState(initialFormState);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // captcha
  const newsletterCanvasRef = useRef(null);
  const [newsletterCaptcha, setNewsletterCaptcha] = useState("");
  const [newsletterCaptchaSession, setNewsletterCaptchaSession] = useState("");
  const [newsletterCaptchaToken, setNewsletterCaptchaToken] = useState("");
const [errors, setErrors] = useState({});
const [successMsg, setSuccessMsg] = useState("");

  const fetchNewsletterCaptcha = useCallback(async () => {
    try {
      const res = await fetch("https://api-uat.mawalog.com/admin/v2/api/website");
      const json = await res.json();

      if (json?.success && json?.data) {
        setNewsletterCaptcha(json.data.captcha_code || "");
        setNewsletterCaptchaSession(json.data.session_id || "");
        setNewsletterCaptchaToken(json.data.token || "");
      } else {
        toast.error("Captcha load failed");
      }
    } catch (err) {
      toast.error("Unable to load captcha");
    }
  }, []);

  useEffect(() => {
    fetchNewsletterCaptcha();
  }, [fetchNewsletterCaptcha]);

  useEffect(() => {
    if (!newsletterCaptcha) return;

    const canvas = newsletterCanvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;

    ctx.clearRect(0, 0, W, H);

    // background
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, W, H);

    // noise curves
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);

      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );

      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.lineWidth = 1 + Math.random();
      ctx.stroke();
    }

    // draw captcha text
    const chars = String(newsletterCaptcha).split("");
    ctx.fillStyle = "#0A3A72";

    chars.forEach((ch, i) => {
      const angle = (Math.random() - 0.5) * 1.2;
      const x = 8 + i * 12;
      const y = 25;

      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);

      ctx.font = "bold 20px Arial";
      ctx.fillText(ch, 0, 0);

      ctx.restore();
    });

    // dots noise
    for (let i = 0; i < 30; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [newsletterCaptcha]);

  // form handling
  const handleChange = (e) => {
    const { name, value } = e.target;

    const patterns = {
      email: /^[a-zA-Z0-9@._+-]*$/,
      captcha: /^\d{0,3}$/,
    };

    if (patterns[name] && !patterns[name].test(value)) return;

    setInputs((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

const validateForm = () => {
  const newErrors = {};
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!inputs.email || inputs.email.trim() === "") {
    newErrors.email = "Email is required";
  } else if (!emailRegex.test(inputs.email)) {
    newErrors.email = "Enter a valid email address";
  }

  if (!inputs.captcha || inputs.captcha.trim() === "") {
    newErrors.captcha = "Captcha is required";
  }

  setErrors(newErrors);

  return Object.keys(newErrors).length === 0;
};
  const MIN_LOADER_TIME = 1200;

  const handleSubscribe = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setIsSubmitting(true);
    const startTime = Date.now();

    try {
      const payload = {
        ...inputs,
        session_id: newsletterCaptchaSession,
        website_type: "Lentera",
      };
      const res = await fetch("https://api.app.mawalog.com/v1.2/newsletter", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-CSRF-TOKEN": newsletterCaptchaToken,
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      const elapsed = Date.now() - startTime;
      const remaining = Math.max(0, MIN_LOADER_TIME - elapsed);

    setTimeout(() => {
  if (!res.ok || !data.success) {
    setErrors({
      captcha: data.message || "Invalid captcha",
    });
    setSuccessMsg(""); // clear success
    fetchNewsletterCaptcha();
  } else {
    setSuccessMsg("Subscribed successfully");
    setErrors({});
    setInputs(initialFormState);
    fetchNewsletterCaptcha();
  }

  setIsSubmitting(false);
}, remaining);
    } catch (error) {
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(0, MIN_LOADER_TIME - elapsed);

      setTimeout(() => {
        setIsSubmitting(false);
        toast.error("Something went wrong.");
      }, remaining);
    }
  };

  return (
    <form onSubmit={handleSubscribe}>
      <div className="flex flex-col items-center gap-4 w-full sm:w-[335px]">
        <div className="w-full">
  <div className="flex items-center bg-[#111215] border border-[#333] px-4 py-3 sm:px-6 sm:py-4 w-full rounded-md">
    <img src={user} alt="user icon" className="w-5 h-5 mr-3" />

    <input
      type="email"
      value={inputs.email}
      name="email"
      onChange={handleChange}
      placeholder="Enter your email"
      className="bg-transparent outline-none text-white placeholder-gray-400 w-full text-sm"
    />
  </div>

  {/* ✅ ERROR BELOW INPUT */}
  {errors.email && (
    <p className="text-red-500 flex items-center justify-center text-sm mt-1">
      {errors.email}
    </p>
  )}
</div>

        {/* Captcha line (canvas + refresh + input + subscribe button) */}
        <div className="w-full flex justify-center">
          <div className="flex items-center gap-3">
            <div className="captcha-box">
              <canvas ref={newsletterCanvasRef} width={60} height={40} />
            </div>

            {/* Refresh button */}
            <button
              type="button"
              onClick={fetchNewsletterCaptcha}
              style={{
                background: "#07862B ",
                color: "#fff",
                border: "none",
                padding: "6px",
                borderRadius: "6px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="23 4 23 10 17 10"></polyline>
                <polyline points="1 20 1 14 7 14"></polyline>
                <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
              </svg>
            </button>

            {/* Captcha input */}
            <input
              type="text"
              placeholder="Enter captcha"
              name="captcha"
              value={inputs.captcha}
              onChange={handleChange}
              className="captcha-input"
            />

    

            {/* Subscribe button */}
            <button
              type="submit"
              disabled={isSubmitting}
              className={`subscribe-button ${isSubmitting ? "opacity-70" : "hover:opacity-90"}`}
            >
              Subscribe
            </button>
            
          </div>
          
        </div>
                {errors.captcha && (
  <p className="text-red-500 text-sm mt-1">
    {errors.captcha}
  </p>
)}

{successMsg && (
  <p className="text-green-600 text-sm mt-3 text-center font-medium">
    ✔ {successMsg}
  </p>
)}

        <style>{`
      .captcha-box {
        width: 60px !important;
        height: 35px !important;
        border-radius: 6px !important;
        overflow: hidden !important;
        color: 131519;
        background-color: #fff !important;
        box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
      }
     
      .captcha-input {
        padding: 11px 8px !important;
        border-radius: 6px !important;
        border: 1px solid #ccc !important;
        outline: none !important;
        width: 100px !important;
        background: #131519 !important;
        color: #fff !important;
        font-size: 10px !important;
      }
     
      .subscribe-button {
        padding: 10px 16px !important;
        border-radius: 8px !important;
        border: none !important;
        background: #07862B !important;
        color: #fff !important;
        font-weight: bold !important;
        font-size: 13px !important;
        cursor: pointer !important;
        white-space: nowrap !important;
      }
     
      @media(max-width:480px){
        .captcha-input { width: 70px !important; font-size: 12px !important; }
        .subscribe-button { padding: 8px 12px !important; font-size: 12px !important; }
      }
    `}</style>
      </div>
    </form>
  );
};

export default Newsletter;
